import { __decorate } from "tslib";
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import colors from '@/styles/color.scss';
let default_1 = class default_1 extends Vue {
    src;
    showBg;
    lazy;
    showSlot;
    isBorder;
    filterImgLv;
    borderColor;
    repeatKey = 0;
    activeBorderColor = this.$props.borderColor;
    activeBoder(val) {
        this.activeBorderColor = val;
    }
    onError() {
        if (this.repeatKey > 4)
            return;
        setTimeout(() => {
            this.repeatKey++;
        }, 100);
    }
    isBlur = localStorage.getItem('privacyMode') === 'true';
};
__decorate([
    Prop()
], default_1.prototype, "src", void 0);
__decorate([
    Prop({ default: true })
], default_1.prototype, "showBg", void 0);
__decorate([
    Prop({ default: true })
], default_1.prototype, "lazy", void 0);
__decorate([
    Prop({ default: true })
], default_1.prototype, "showSlot", void 0);
__decorate([
    Prop({ default: true })
], default_1.prototype, "isBorder", void 0);
__decorate([
    Prop({ default: 0 })
], default_1.prototype, "filterImgLv", void 0);
__decorate([
    Prop({ default: colors.borderItemHover })
], default_1.prototype, "borderColor", void 0);
__decorate([
    Watch('borderColor')
], default_1.prototype, "activeBoder", null);
__decorate([
    Emit('onError')
], default_1.prototype, "onError", null);
default_1 = __decorate([
    Component({
        name: '',
        components: { BlurPicture },
        i18n: {
            messages: {
                zh: {},
                en: {},
            },
        },
    })
], default_1);
export default default_1;
